<template>
  <div class="floating-strip" v-if="floatData">
    <div class="left-icon">
      <img :src="floatData.imgUrl" />
    </div>
    <div class="middle-text">
      <div class="float-title">{{floatData.floatTitle}}</div>
      <div class="float-countdown">
        <van-count-down :time="lastTime" @change="downChange" format="HH:mm:ss" @finish="activelFinish"></van-count-down>
        <!-- <van-count-down :time="lastTime" @change="downChange" @finish="activelFinish">
          <template #default="timeData">
            <span class="time_item" v-if="timeData.days > 0">{{timeData.days}}</span>
            <span class="item" v-if="timeData.days > 0">:</span>
            <span class="time_item">{{ timeData.hours }}</span>
            <span class="item">:</span>
            <span class="time_item">{{ timeData.minutes }}</span>
            <span class="item">:</span>
            <span class="time_item">{{ timeData.seconds }}</span>
          </template>
        </van-count-down> -->
      </div>

      <!-- <div class="float-countdown">{{floatData.expiredDate}}</div> -->
    </div>
    <div class="right-button">
      <p @click="handleJump">{{floatData.buttonTitle}}</p>
      <i @click="floatData = null">
        <img :src="floatData.closeImage" />
      </i>
    </div>
  </div>
</template>

<script>
import { freshFloatStripApi } from "@/libs/api.js";
export default {
  name: "couponItem",
  props: {
    scene: {
      type: String,
      default: () => '',
    },
    visualChannel: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      params: {
        visualChannel: 'app_ylxdsq',
        scene: ''
      },
      floatData: null,
      isOver: false,
      lastTime: '',
      time: ''
    };
  },
  mounted() {
    if (this.visualChannel) {
      this.params.visualChannel = this.visualChannel
    } else {
      if (this.$browser().ylxdsq || this.$browser().ulemax) {
        this.params.visualChannel = 'app_ylxdsq'
      } else {
        this.params.visualChannel = 'wap_ylxdsq'
      }
    }
    this.params.scene = this.scene
    console.log('this.params==', this.params)
    this.getFloatStrip();
  },
  methods: {
    getFloatStrip() {
      freshFloatStripApi(this.params).then(res => {
        console.log('res==', res)
        if (res.returnCode == '0000' && res.data && res.data.length > 0) {
          this.time = res.time
          this.floatData = res.data[0]
          this.lastTime = this.$moment(this.floatData.expiredDate).diff(this.time).toString();
          console.log('lastTime===', this.lastTime)
        }
      })
    },
    downChange(e) {
      if (e.hours < 10) {
        e.hours = `0${e.hours}`;
      }
      if (e.minutes < 10) {
        e.minutes = `0${e.minutes}`;
      }
      if (e.seconds < 10) {
        e.seconds = `0${e.seconds}`;
      }
    },
    activelFinish() {
      this.isOver = true;
      this.floatData = null;
    },
    handleJump() {
      if (this.$browser().version >= 327) {
        console.log('freshUrl', this.floatData.freshUrl)
        console.log('originalId', this.floatData.originalId)
        if (this.floatData.orginId) {
          dsBridge.call("jumpWxMiniProgram", { "path": this.floatData.freshUrl, "originalId": this.floatData.orginId })
        }
      } else {
        if (this.$browser().ylxdsq || this.$browser().ulemax) {
          this.$toast('抱歉,您的APP版本过低,请下载最新版APP');
        } else {
          window.location.href = this.floatData.link;
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.floating-strip {
  width: 100%;
  height: 36px;
  background: #fff6e7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  .left-icon {
    width: 18px;
    height: 20px;
    img {
      width: 18px;
      height: 20px;
      display: block;
    }
  }
  .middle-text {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    max-width: 70%;
    white-space: nowrap;
    overflow: hidden;
    .float-title {
      font-size: 12px;
      color: #1e1e1e;
      margin-right: 4px;
    }
    .float-countdown {
      .van-count-down {
        color: #f78c00;
        font-size: 12px;
      }
      font-size: 12px;
      color: #f78c00;
    }
  }
  .right-button {
    font-size: 12px;
    color: #ab4e22;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: 75px;
    overflow: hidden;
    p {
      margin-right: 4px;
    }
    i {
      width: 12px;
      height: 12px;
      display: block;
      img {
        width: 12px;
        height: 12px;
        display: block;
      }
    }
  }
}
</style>
